import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Dairy Brand — Reorder campaign. Real lifetime aggregates from
// ANALYTICS.ADS.CAMPAIGN_PERIODS over the 19 complete months Feb 2025 – Aug 2026;
// it started a year after the new-customers campaign and is still running.
//
// The largest reorder program of any variant by a wide margin — 412 conversions
// against Zotter's 13 — and the only one where reorder is a standing part of the
// mix rather than a short experiment. It returns 7.0x, close enough to the new
// side's 7.4x that neither campaign is obviously the one to cut.
//
// `monthlyBudgetDollars` is the shared $6,000 pool; see camp_db_new. CAMPAIGN_PERIODS
// attributes no first-year value to the reorder segment, so its sales come from
// TOTAL_LOCAL_POST_DISCOUNT and the return is measured directly against spend.
export const campDbReorder: FaireAdCampaignEntity = {
  token: "camp_db_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_dairy_brand",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 6000,
  startedRunningAt: "2025-02-14",
  segmentMetrics: {
    numReorderConversions: 412,
    salesDollars: 75439,
    totalAdsSpendDollars: 10723,
    returnOnAdSpend: 7.03,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-19T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
